import React, { useState, useEffect } from "react";
import "./ProductCard.css";
import { connect } from "react-redux";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";

import { useDispatch, useSelector } from "react-redux";
import {
  fetchAllWishlistsAsync,
  selectAllWishlists,
  addToWishlistsAsync,
  removeFromWishlistAsync,
} from "../../features/wishlist/wishlistSlice";
import { fetchAllCartsAsync } from "../../features/cartPage/cartPageSlice";
import { selectUser } from "../../features/auth/authSlice";
import {
  toggleOverlay,
  selectIsOverlayVisible,
} from "../../store/slices/headerSlice";
import HoverSlider from "../ListingPage/ListingProduct/HoverSlider";
import { useNavigate } from "react-router";
import SelectDesktopVariant from "../EndPages/SelectDesktopVariant";
import cartOutlineLogo from "../../img/navigation/cart-bookmark-outline.png";
import cartFilledLogo from "../../img/navigation/cart-bookmark-filled.png";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import StarIcon from "@mui/icons-material/Star";
import {
  calculateDealerPrice,
  calculateUpdatedDiscountPercentage,
  formatWithCommasWithDecimal,
} from "../../utils/utils";
import { trackEvent } from "../../analytics/gtag";
import { EVENTS } from "../../analytics/events";

function ProductCard({ toggleOverlay }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const wishlist = useSelector(selectAllWishlists);
  const products = wishlist?.product;
  const qtys = wishlist?.quantity;
  const userDetail = useSelector(selectUser);
  const [openDesktopVariant, setOpenDesktopVariant] = useState(null);

  const [open, setOpen] = useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  const handleOpen = () => {
    setOpen(true);
  };

  useEffect(() => {
    if (userDetail.UserID) {
      dispatch(fetchAllWishlistsAsync(userDetail.UserID));
      dispatch(fetchAllCartsAsync(userDetail.UserID));
    }
  }, [dispatch, userDetail.UserID]);

  const handleLoginOverlay = (e) => {
    toggleOverlay();
    e.preventDefault();
  };

  // TO ADD PRODUCT INTO WISHLIST
  const handleAddToWishlist = async (data, e) => {
    handleOpen();
    let wishlistData = {
      UserID: userDetail?.UserID,
      prodID: data?.prod_ID,
    };
    dispatch(addToWishlistsAsync(wishlistData)).then(() =>
      dispatch(fetchAllWishlistsAsync(userDetail.UserID)).then(() => {
        handleClose();
      })
    ); // Fetch updated wishlist
    e.preventDefault();
  };

  const handleRemoveFromWishlist = async (data, e) => {
    handleOpen();
    let wishlistData = {
      UserID: userDetail?.UserID,
      prodID: data?.prod_ID,
    };
    dispatch(removeFromWishlistAsync(wishlistData)).then(() => {
      dispatch(fetchAllWishlistsAsync(userDetail.UserID)).then(() => {
        handleClose();
      });
    });
    e.preventDefault();
  };

  // Function to check if a product is in the wishlist
  const isInWishlist = (productId) => {
    return (
      Array.isArray(wishlist && wishlist?.product) &&
      wishlist?.product?.some((item) => item.prod_ID === productId)
    );
  };

  const handleNavigate = (prod_id, event) => {
    event.preventDefault();
    navigate(`/product/${prod_id}`);
    // Analytics
    trackEvent({
      action: EVENTS.VIEW_PRODUCT,
      category: "Product",
      label: `User Visited Product ${prod_id}`,
      value: userDetail?.PhoneNumber
    });
  };

  const handleOpenDesktopVariant = (id, e) => {
    setOpenDesktopVariant(id);
    e.preventDefault();
  };

  const handleMouseEnter = () => {
    return;
  };

  const handleMouseLeave = () => {
    return;
  };

  const isOutOfStock = (productId) => {
    // Check if qtys is defined before destructuring
    if (!qtys) {
      // Handle the case where qtys is undefined
      return true; // Or any other logic you want when qtys is undefined
    }

    // Destructure CCQuantity from qtys if qtys is defined
    const { CCQuantity } = qtys;

    // Flatten the nested arrays into a single array of product objects
    const allProducts = CCQuantity?.flat();

    // Filter products matching the given productId
    const matchingProducts = allProducts?.filter(
      (product) => product?.prod_ID === productId
    );

    // If no matching products are found, return true (considered out of stock)
    if (matchingProducts?.length === 0) {
      return true;
    }

    // Check if all matching products have qty of 0
    return matchingProducts?.every((product) => product?.qty === 0);
  };

  return (
    <div className="wishlist-slider-container">
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open} // Show backdrop when either open or filtering state is true
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <div className="wishlist-slider-main-container">
        {(products || []).map((data) => (
          <div className="wishlist-slider-card-container" key={data?.prod_ID}>
            {data?.Badges && (
              <div className="wishlist-slider-card-product-badges-container">
                <img
                  loading="lazy"
                  src={`https://cyclecircle.blr1.cdn.digitaloceanspaces.com/Logo/${
                    data?.Badges && data?.Badges
                  }`}
                  alt=""
                  className="product-slider-card-product-badges"
                />
              </div>
            )}
            <div className="wishlist-slider-card-favourite-container">
              {isInWishlist(data?.prod_ID) ? (
                <img
                  loading="lazy"
                  src={cartFilledLogo}
                  alt=""
                  onClick={(e) => {
                    handleRemoveFromWishlist(data, e);
                  }}
                  id="product-slider-card-favourite-svg"
                />
              ) : (
                <img
                  loading="lazy"
                  src={cartOutlineLogo}
                  alt=""
                  onClick={(e) => {
                    userDetail && userDetail?.UserID
                      ? handleAddToWishlist(data, e)
                      : handleLoginOverlay(e);
                  }}
                  id="product-slider-card-favourite-svg"
                />
              )}
            </div>
            <div
              className="wishlist-slider-card-image-container"
              onClick={(event) => {
                handleNavigate(data.prod_ID, event);
              }}
            >
              <HoverSlider images={data?.images && data.images} />
            </div>
            <div className="w-full h-auto flex flex-col justify-start relative pt-[10px] pr-[8px] pb-0 pl-[10px]">
              <div className="products-list-card-product-ratings-container">
                <span className="products-list-card-product-rating">
                  {parseInt(data.net_rating).toFixed(1)}
                </span>
                <StarIcon id="product-list-card-star-svg" />
                <span className="products-list-card-product-rating-divider">
                  |
                </span>
                <span className="products-list-card-product-no-of-rating">
                  313
                </span>
              </div>
              <div className="absolute right-[15px] top-[-10px] opacity-100 transition-all duration-200">
                {isOutOfStock(data.prod_ID) ? (
                  <span className="text-peach text-[14px] font-bold">
                    Out of Stock
                  </span>
                ) : (
                  <ShoppingCartOutlinedIcon
                    onClick={(e) => {
                      userDetail && userDetail?.UserID
                        ? handleOpenDesktopVariant(data.prod_ID, e)
                        : handleLoginOverlay(e);
                    }}
                    className=" text-white-1 bg-green rounded-[2px] p-[2px]"
                    style={{ fontSize: "20px" }}
                  />
                )}
              </div>
              {data && data?.manufacture_images ? (
                <img
                  loading="lazy"
                  className="w-[80px] h-[35px] object-contain"
                  src={`https://cyclecircle.blr1.cdn.digitaloceanspaces.com/${process.env.REACT_APP_IMAGE_BASE}_MANUFACTURE_IMAGE/${
                    data && data?.manufacture_images
                  }`}
                  alt=""
                />
              ) : (
                <span className="h-[35px] text-[12px] italic font-bold">
                  {data.manufacture_name && data.manufacture_name}
                </span>
              )}
              <div className="w-auto min-h-[40px] flex items-center justify-start">
                <span className="text-[13px] font-bold m-0 text-blue capitalize tracking-wide line-clamp-2">
                  {data && (
                    <>
                      {data?.prod_name + ", " || ""}
                      {data?.product_Tech?.map((tech) => tech).join(" ")}
                    </>
                  )}
                </span>
              </div>
              <div className="w-full h-auto flex flex-col items-start justify-start relative pb-3">
                <div className="flex items-center justify-center">
                  {data &&
                    data?.skuDetails &&
                    data?.skuDetails?.length > 0 &&
                    data?.skuDetails[0]?.NDP_Price && (
                      <>
                        <span className="text-[15px] font-bold capitalize text-[rgba(0,0,0,0.8)]">
                          Sale Price -{" "}
                          <b>
                            ₹
                            {formatWithCommasWithDecimal(
                              calculateDealerPrice(
                                parseInt(data.skuDetails[0].MRP_price),
                                parseInt(data.skuDetails[0].NDP_Price),
                                data?.GST
                              )
                            )}
                          </b>
                        </span>
                      </>
                    )}
                </div>
                <div className="text-sm text-gray-600 flex items-center mt-1">
                  {data?.skuDetails?.length > 0 &&
                    data?.skuDetails[0]?.MRP_price && (
                      <span className="block text-gray-500 text-xs font-medium tracking-wide">
                        MRP - ₹
                        {formatWithCommasWithDecimal(
                          parseInt(data.skuDetails[0].MRP_price)
                        )}
                      </span>
                    )}

                  {calculateUpdatedDiscountPercentage(
                    data?.skuDetails[0]?.MRP_price,
                    data?.skuDetails[0]?.NDP_Price,
                    data?.GST
                  ) >= 1 && (
                    <div className="flex items-center gap-1 ml-4">
                      <span className="text-red-500 text-xs">
                        {calculateUpdatedDiscountPercentage(
                          data?.skuDetails[0]?.MRP_price,
                          parseInt(data.skuDetails[0].NDP_Price),
                          data?.GST
                        )}
                        % off
                      </span>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
      {openDesktopVariant !== null && (
        <SelectDesktopVariant
          handleMouseEnter={handleMouseEnter}
          handleMouseLeave={handleMouseLeave}
          openDesktopVariant={openDesktopVariant}
          setOpenDesktopVariant={setOpenDesktopVariant}
          product={products.find((item) => item.prod_ID === openDesktopVariant)}
          qtys={qtys}
        />
      )}
    </div>
  );
}

const mapStateToProps = (state) => ({
  isOverlayVisible: selectIsOverlayVisible(state),
});

const mapDispatchToProps = {
  toggleOverlay,
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductCard);
